export enum SwitcherIds {
  THEME,
  FONT,
  COLOR,
}
